var map = {
	"./gltfs/book/Catalogue.glb": 556,
	"./gltfs/suzanne/Suzanne_BaseColor.png": 557,
	"./gltfs/suzanne/Suzanne_MetallicRoughness.png": 558,
	"./ibl/Helipad/env.png": 493,
	"./ibl/Helipad/sh.bin": 494,
	"./sample/matcap_clay.jpg": 559,
	"./sample/matcap_red_plastic.jpg": 560,
	"./sample/matcap_white.jpg": 561,
	"./sample/texture1.jpg": 562,
	"./sample/texture1.jpg.astc.ktx": 563,
	"./sample/texture1.jpg.dxt.ktx": 564,
	"./sample/texture1.jpg.etc.ktx": 565,
	"./sample/texture1.jpg.pvr.ktx": 566,
	"./sample/texture1.jpg.webp": 567,
	"./sample/texture2.jpg": 568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 555;